export const GET_SUBSCRIPTION = 'subscription/GET';
export const SUBSCRIBE = 'subscription/CREATE';
export const CANCEL_SUBSCRIPTION = 'subscription/CANCEL';
export const CHANGE_PAYMENT = 'subscription/CHANGE_PAYMENT';

export const CANCEL_SUBSCRIPTION_MODAL = 'cancelSubscription';
export const CHANGE_PAYMENT_MODAL = 'changePayment';

export const DATE_FORMAT = 'D MMM YYYY';
